export interface QuantPreviewDisabledProps {
  /** Why this strategy has no live preview (server or client sentence, shown as given). */
  reason: string
}

/**
 * The notice that replaces the live preview panel for a strategy without one
 * (spec 039 3.2). A fixed 72px card, so nothing resizes after data arrives.
 * Presentational only.
 */
export function QuantPreviewDisabled({ reason }: QuantPreviewDisabledProps) {
  return (
    <div
      data-preview-disabled
      className="flex h-[72px] min-w-0 flex-col justify-center gap-1 overflow-hidden border border-paper-14 px-3.5"
    >
      <span className="font-sans text-[11px] font-bold tracking-[0.2em] uppercase">No live preview</span>
      <span className="line-clamp-2 font-mono text-[11px] leading-[15px] text-paper-50" title={reason}>
        {reason}
      </span>
    </div>
  )
}
